import TtamBehaviorHashtagCategory from './behavior-hashtag-category/index.vue';
import TtamBehaviorHashtagPreofflineHashtagAlert from './preoffline-hashtag-alert/index.vue';
import TtamBehaviorHashtagOfflineHashtagAlert from './offline-hashtag-alert/index.vue';
import * as hooks from './hooks';
export default {
  TtamBehaviorHashtagCategory,
  TtamBehaviorHashtagPreofflineHashtagAlert,
  TtamBehaviorHashtagOfflineHashtagAlert,
  ...hooks,
};
